<template>
    <div class="check-content-form">
        <el-form :model="form" label-width="180px" label-position="right" label-suffix="：">
            <!-- 异常SKU名称引流 -->
            <el-form-item label="关键词违规">
                <el-checkbox v-model="form.skuNameAbnormalWords_check" />
                <span class="span_spacing">检测：SKU名称包含</span>
                <el-input type="textarea" :rows="1" :disabled="!form.skuNameAbnormalWords_check"
                    v-model="form.skuNameAbnormalWords" placeholder="输入关键词" style="width: 450px; margin-left: 8px;"
                    size="small" />
            </el-form-item>

            <!-- 异常SKU名称引流 -->
            <el-form-item label="尺码违规">
                <el-checkbox v-model="form.skuSizeAbnormalWords_check" />
                <span class="span_spacing">检测：SKU尺码包含</span>
                <el-input type="textarea" :rows="1" :disabled="!form.skuSizeAbnormalWords_check"
                    v-model="form.skuSizeAbnormalWords" placeholder="输入尺码" style="width: 450px; margin-left: 8px;"
                    size="small" />
            </el-form-item>

            <el-form-item label="商品价格公式">
                <el-checkbox v-model="form.skuAmountCal_check" />
                <span class="span_spacing">原价格 x</span>
                <!-- <el-input class="w80 ml8" :disabled="!form.skuAmountCal_check" v-model="form.coefficient" size="small"></el-input> -->
                <el-input-number v-model="num" :precision="2" :min="1" :step="0.1" :disabled="!form.skuAmountCal_check"
                    v-model.number="form.coefficient" placeholder="倍数" size="small" />
                <span class="span_spacing">倍 + 加价</span>

                <!-- <el-select class="w80 ml8" :disabled="!form.skuAmountCal_check"
                    v-model="form.coefficient_type" size="small">
                    <el-option label="+" :value="1">+</el-option>
                    <el-option label="-" :value="2">-</el-option>
                </el-select> -->
                <!-- <el-input class="w80 ml8" :disabled="!form.skuAmountCal_check" v-model="form.coefficient_money"></el-input> -->
                <el-input-number v-model="num" :precision="2" :min="1" :step="0.1" :disabled="!form.skuAmountCal_check"
                    v-model.number="form.coefficient_money" placeholder="金额" size="small" />
                <span class="span_spacing">元 x 折扣</span>
                <el-input-number v-model="num" :precision="2" :step="1" :min="1" :max="10"
                    :disabled="!form.skuAmountCal_check" v-model.number="form.amountDiscount" placeholder="折扣"
                    size="small" />
                <span class="span_spacing">折（{{ (parseFloat(form.amountDiscount) * 0.1).toFixed(2) }}）</span>
                <!-- <span class="span_spacing">检测：商品最高价SKU大于最低价SKU</span>
        <el-input-number v-model="num" :precision="2" :step="0.1"
          :disabled="!form.skuAmountMaxMinGap_check"
          v-model.number="form.skuAmountMaxMinGap"
          placeholder="倍数"
          size="small"
        /> -->
            </el-form-item>

            <!-- <el-form-item>
                <el-checkbox v-model="form.skuAmountCal_check" />
                <span class="span_spacing">销售价格 x</span>
                <el-input-number v-model="num" :precision="2" :step="0.1" :max="1" :disabled="!form.skuAmountCal_check"
                    v-model.number="form.amountDiscount" placeholder="折扣" size="small" />

                <el-select class="w80 ml8 span_spacing" :disabled="!form.skuAmountCal_check"
                    v-model="form.amountDiscount_type" size="small">
                    <el-option label="-" :value="2">-</el-option>
                </el-select>
                <el-input-number v-model="num" :precision="2" :step="0.1" :disabled="!form.skuAmountCal_check"
                    v-model.number="form.amountDiscount_money" placeholder="金额" size="small" />
                <span class="span_spacing">元</span>
            </el-form-item> -->
            <!-- 商品价格异常 -->
            <!-- <el-form-item label="商品价格违规检测">
                <el-checkbox v-model="form.skuAmountAbnormal_check" />
                <span class="span_spacing">检测：商品SKU是否存在价格违规</span>
            </el-form-item> -->
            <el-form-item>
                <template #label>
                    <span>商品价格违规检测</span>
                    <el-tooltip content="该功能普通会员使用收费1个链接0.1算力。个人会员，企业会员使用免费" placement="top">
                        <i class="el-icon-question" style="color: #909399; cursor: pointer; margin-left: 4px;"></i>
                    </el-tooltip>
                </template>
                <el-checkbox v-model="form.skuAmountAbnormal_check" />
                <span class="span_spacing">检测：商品SKU是否存在价格违规</span>
            </el-form-item>

            <el-form-item label="商品价格异常">
                <el-checkbox v-model="form.skuAmountMaxMinGap_check" />
                <span class="span_spacing">检测：商品最高价SKU大于最低价SKU</span>
                <el-input-number v-model="num" :precision="2" :step="0.1" :disabled="!form.skuAmountMaxMinGap_check"
                    v-model.number="form.skuAmountMaxMinGap" placeholder="倍数" size="small" />
                <span class="span_spacing">倍</span>
            </el-form-item>
            <el-form-item>
                <div>
                    <el-checkbox v-model="form.skuAmountMaxMinGapMoney_check" />
                    <span class="span_spacing">检测：商品最高价SKU超过最低价SKU</span>
                    <el-input-number v-model="num" :precision="2" :step="0.1"
                        :disabled="!form.skuAmountMaxMinGapMoney_check" v-model.number="form.skuAmountMaxMinGapMoney"
                        placeholder="输入检测金额" size="small" />
                    <span class="span_spacing">元</span>
                </div>
            </el-form-item>
            <el-form-item>
                <div>
                    <el-checkbox v-model="form.skuAmountMaxLimit_check" />
                    <span class="span_spacing">检测：商品最高价超过</span>
                    <el-input-number v-model="num" :precision="2" :step="0.1" :disabled="!form.skuAmountMaxLimit_check"
                        v-model.number="form.skuAmountMaxLimit" placeholder="输入检测金额" size="small" />
                    <span class="span_spacing">元</span>
                </div>
            </el-form-item>
            <el-form-item>
                <div>
                    <el-checkbox v-model="form.skuAmountMinLimit_check" />
                    <span class="span_spacing">检测：商品最低价低于</span>
                    <el-input-number v-model="num" :precision="2" :step="0.1" :disabled="!form.skuAmountMinLimit_check"
                        v-model.number="form.skuAmountMinLimit" size="small" />
                    <span class="span_spacing">元</span>
                </div>
            </el-form-item>

            <!-- 异常SKU名称引流 -->
            <el-form-item label="选择分组">
                <div>
                    <el-checkbox v-model="form.groupAbnormal" />
                    <span class="span_spacing">检测：选择分组</span>
                    <el-select size="small" :disabled="!form.groupAbnormal" v-model="form.group_ids" class="w220"
                        multiple filterable clearable placeholder="全部" @change="changeGroupIds">
                        <el-option v-for="group in groupList" :key="group.id" :label="group.name"
                            :value="group.id"></el-option>
                    </el-select>
                </div>
                <div>
                    <el-checkbox v-model="form.groupAbnormal" />
                    <span class="span_spacing">检测：选择子分组</span>
                    <el-select size="small" :disabled="!form.groupAbnormal" v-model="form.child_group_id" class="w220"
                        multiple filterable clearable placeholder="全部">
                        <el-option v-for="group in child_groupList" :key="group.id" :label="group.name"
                            :value="group.id"></el-option>
                    </el-select>
                </div>
            </el-form-item>
            <!-- 异常SKU名称引流 -->
            <el-form-item label="SKU替换">
                <el-checkbox v-model="form.skuReplace_check" />
                <span class="span_spacing">检测：选择SKU替换</span>
                <!-- <el-tag
          v-for="tag in form.skuNameKeywords"
          :key="tag"
          closable
          style="margin-left: 8px;"
          @close="removeSkuNameTag(tag)"
        >
          {{ tag }}
        </el-tag> -->
                <el-select class="w0 ml8" :disabled="!form.skuReplace_check" v-model="form.skuReplace">
                    <el-option label="已替换" :value="1">已替换</el-option>
                    <el-option label="未替换" :value="2">未替换</el-option>
                </el-select>
            </el-form-item>
            <!-- 异常SKU名称引流 -->
            <el-form-item v-if="!view_flag">
                <el-button type="success" :loading="btn_loading" @click="skudetectionForecast">预估需检测商品数:{{
                    this.process_count }}个</el-button>
                <el-button type="primary" v-if="this.process_count > 0" :loading="btn_loading"
                    @click="skudetectionSubmit">提交检测</el-button>
            </el-form-item>

            <!-- SKU低价规格深度检测 -->
            <!-- <el-form-item label="SKU低价规格深度检测">
        <el-checkbox v-model="form.skuSpecAbnormal" />
        <span>检测：SKU规格不合理</span>
      </el-form-item> -->
        </el-form>
    </div>
</template>

<script>
import { mapActions } from "vuex";
export default {
    name: 'CheckContentForm',
    props: {
        info: {
            type: Object,
            default: () => { } // 默认空对象
        }
    },
    watch: {
        // 监听 info 变化，并且立即执行一次
        info: {
            handler(val) {
                // 第一时间判断是否有值
                this.setinfo(val)
            },
            immediate: true, // 关键：组件一创建就执行
            deep: true        // 如果对象内部属性变化也要监听
        }
    },
    mounted() {

    },
    created() {
        this.getGroupList()
        if (!this.info) {
            this.getFirstInfo();
        }
    },
    data() {
        return {
            view_flag: false,
            btn_loading: false,
            groupList: [],
            child_groupList: [],
            process_count: 0,
            form: {
                //售价公式
                amountDiscount: 0,
                amountDiscount_type: 2,
                amountDiscount_money: 0,
                //价格公式
                skuAmountCal_check: false,
                coefficient: 0,
                coefficient_type: 1,
                coefficient_money: 0,
                skuReplace_check: false,
                skuReplace: '',
                // 异常SKU名称引流
                skuNameAbnormalWords_check: true,
                skuNameAbnormalWords: '定金，订金，邮费，赠品，换购，试用，样品，瑕疵品，二手，模型，缺货，联系客服，下单不发货，不建议拍下，运费，定金，订金，补差，差价，不发货，勿拍，不要拍，专拍，改价，备注，注意事项，试用，试吃，小样，样品，一片，1片， 一张，1张，一瓶，1瓶',
                skuSizeAbnormalWords_check: true,
                skuSizeAbnormalWords: 'XXXXXXXXXS，XXXXXXXXS，XXXXXXXS，XXXXXXS，XXXXXS，XXXXS，XXXS，XXS，XS，58码',
                // 套装/零配件拆卖
                suitSplitSell: false,
                suitSplitKeywords: '',
                // 异常运费
                abnormalFreight: false,
                abnormalFreightAmount: null,
                virtualProductFreight: true,
                // 商品价格异常
                skuAmountMaxMinGap_check: false,
                skuAmountAbnormal_check: true,
                skuAmountMaxMinGap: null,
                skuAmountMaxMinGapMoney_check: false,
                skuAmountMaxMinGapMoney: null,
                skuAmountMaxLimit_check: false,
                skuAmountMaxLimit: null,
                skuAmountMinLimit_check: false,
                skuAmountMinLimit: null,
                // SKU低价规格深度检测
                skuSpecAbnormal: true,
                groupAbnormal: false,
                group_ids: '',
                child_group_id: '',
                group_names: '',
            },
            skuNameInput: ''
        }
    },
    methods: {
        ...mapActions({
            getCloudProductGroups: 'ucenter/getCloudProductGroups',
            opSkudetectionSubmit: 'ucenter/opSkudetectionSubmit',
            opskudetectionForecast: 'ucenter/opskudetectionForecast',
            opGetSkudetectionPage: 'ucenter/opGetSkudetectionPage',
        }),
        // 获取分组列表
        getGroupList() {
            this.getCloudProductGroups({
                data: { with_count: 0 },
                success: (res) => {
                    if (res.code === 200) {
                        this.groupList = res.data || []
                        if (this.groupList.length > 0) {
                            const tem_child_group_id = this.form.child_group_id
                            if (tem_child_group_id) {
                                this.changeGroupIds(this.form.group_ids);
                                this.form.child_group_id = tem_child_group_id
                            }
                        }
                    }
                }
            })
        },
        setinfo(val) {
            if (val && Object.keys(val).length > 0) {
                this.view_flag = true
                // 初始化数据
                if (val.sku_name_abnormal_words) {
                    this.form.skuNameAbnormalWords_check = true
                    this.form.skuNameAbnormalWords = val.sku_name_abnormal_words
                } else {
                    this.form.skuNameAbnormalWords_check = false
                    this.form.skuNameAbnormalWords = ''
                }
                // 初始化数据
                if (val.sku_size_abnormal_words) {
                    this.form.skuSizeAbnormalWords_check = true
                    this.form.skuSizeAbnormalWords = val.sku_size_abnormal_words
                } else {
                    this.form.skuSizeAbnormalWords_check = false
                    this.form.skuSizeAbnormalWords = ''
                }

                if (val.coefficient) {
                    this.form.skuAmountCal_check = true
                    this.form.coefficient = val.coefficient
                    this.form.coefficient_type = val.coefficient_type

                    this.form.amountDiscount = val.amount_discount
                    if (val.coefficient_money) {
                        this.form.coefficient_money = val.coefficient_money
                    }
                    if (val.amount_discount_money) {
                        this.form.amountDiscount_money = val.amount_discount_money
                    }
                } else {
                    this.form.coefficient = 0
                    this.form.coefficient_type = 1
                    this.form.amountDiscount = 0
                    this.form.coefficient_money = 0
                    this.form.skuAmountCal_check = false
                }

                if (val.sku_amount_max_min_gap) {
                    this.form.skuAmountMaxMinGap_check = true
                    this.form.skuAmountMaxMinGap = val.sku_amount_max_min_gap
                } else {
                    this.form.skuAmountMaxMinGap_check = false
                    this.form.skuAmountMaxMinGap = 0
                }
                if (val.sku_amount_max_min_gap) {
                    this.form.skuAmountAbnormal_check = true
                } else {
                    this.form.skuAmountAbnormal_check = false
                }

                if (val.sku_amount_max_min_gapmoney) {
                    this.form.skuAmountMaxMinGapMoney_check = true
                    this.form.skuAmountMaxMinGapMoney = val.sku_amount_max_min_gapmoney
                } else {
                    this.form.skuAmountMaxMinGapMoney_check = false
                    this.form.skuAmountMaxMinGapMoney = 0
                }

                if (val.sku_amount_max_limit) {
                    this.form.skuAmountMaxLimit_check = true
                    this.form.skuAmountMaxLimit = val.sku_amount_max_limit
                } else {
                    this.form.skuAmountMaxLimit_check = false
                    this.form.skuAmountMaxLimit = 0
                }

                if (val.sku_amount_min_limit) {
                    this.form.skuAmountMinLimit_check = true
                    this.form.skuAmountMinLimit = val.sku_amount_min_limit
                } else {
                    this.form.skuAmountMinLimit_check = false
                    this.form.skuAmountMinLimit = 0
                }
                if (val.group_ids) {
                    this.form.groupAbnormal = true
                    this.form.group_ids = val.group_ids.split(',').map(item => parseInt(item));
                    this.changeGroupIds(this.form.group_ids);
                    if (val.child_group_id) {
                        this.form.child_group_id = val.child_group_id
                    }
                } else {
                    this.form.groupAbnormal = false
                    this.form.group_ids = ''
                    this.form.child_group_id = []
                }
                if (val.sku_is_replace && val.sku_is_replace <= 2) {
                    this.form.skuReplace_check = true
                    this.form.skuReplace = val.sku_is_replace
                } else {
                    this.form.skuReplace_check = false
                    this.form.skuReplace = ''
                }
            } else {
                this.view_flag = false
            }
        },
        //获取检测列表
        getFirstInfo() {
            let param = { page_size: 1, page: 1 }
            this.opGetSkudetectionPage({
                data: param,
                success: (res) => {
                    if (res.code == 200) {
                        const firstItem = res.data.list?.[0];
                        if (firstItem) {
                            // 处理第一条数据
                            this.setinfo(firstItem);
                        }
                    } else {
                        this.$message.error(res.message)
                    }
                    this.view_flag = false
                }
            })
        },
        //提交sku低价检测
        skudetectionSubmit() {
            this.btn_loading = true
            if (this.form.skuAmountCal_check && (this.form.coefficient <= 0 || this.form.amountDiscount <= 0)) {
                this.$message.error('原价格和销售价格倍数必须大于0')
                this.btn_loading = false
                return
            }

            if (this.form.skuNameAbnormalWords_check) {
                if (this.form.skuNameAbnormalWords.includes(',')) {
                    this.$message.error('英文逗号不是分隔符');
                    this.btn_loading = false
                    return
                }
            }

            if (this.groupList) {
                this.form.group_names = this.groupList.filter(i => this.form.group_ids.includes(i.id)).map(i => i.name)
            }

            this.opSkudetectionSubmit({
                data: this.form,
                success: (res) => {
                    this.btn_loading = false
                    if (res.code === 200) {
                        this.$message.success('检测任务已生成，检测编号：' + res.data.task_no)
                        this.$emit('submitted', res.data.task_no)
                    } else {
                        this.$message.error(res.message)
                    }
                }
            })
        },
        //预估商品数量
        skudetectionForecast() {
            this.btn_loading = true
            if (this.form.skuAmountCal_check && (this.form.coefficient <= 0 || this.form.amountDiscount <= 0)) {
                this.$message.error('原价格和销售价格倍数必须大于0')
                this.btn_loading = false
                return
            }

            if (this.form.skuNameAbnormalWords_check) {
                if (this.form.skuNameAbnormalWords.includes(',')) {
                    this.$message.error('英文逗号不是分隔符');
                    this.btn_loading = false
                    return
                }
            }

            if (this.groupList) {
                this.form.group_names = this.groupList.filter(i => this.form.group_ids.includes(i.id)).map(i => i.name)
            }

            this.opskudetectionForecast({
                data: this.form,
                success: (res) => {
                    this.btn_loading = false
                    if (res.code === 200) {
                        this.process_count = res.data.process_count
                        this.$message.success('预估商品数：' + this.process_count)
                    } else {
                        this.$message.error(res.message)
                    }
                }
            })
        },
        // 添加SKU名称标签
        addSkuNameTag() {
            if (this.skuNameInput && !this.form.skuNameKeywords.includes(this.skuNameInput)) {
                this.form.skuNameKeywords.push(this.skuNameInput)
                this.skuNameInput = ''
            }
        },
        // 移除SKU名称标签
        removeSkuNameTag(tag) {
            const index = this.form.skuNameKeywords.indexOf(tag)
            if (index > -1) {
                this.form.skuNameKeywords.splice(index, 1)
            }
        },
        changeGroupIds(val) {
            this.$set(this.form, 'child_group_id', [])
            this.child_groupList = this.groupList.filter(i => val.includes(i.id)).map(i => i.child_groups || []).flat()
        },
    }
}
</script>

<style scoped>
.check-content-form {
    padding: 20px;
}

.el-tag {
    margin-bottom: 5px;
}

.span_spacing {
    padding: 0 5px 0 5px;
}

.con {
    width: 90%;
    display: flex;
    align-items: center;
    height: 40px;
}

.con .t {
    font-size: 14px;
    white-space: nowrap;
    margin: 0 10px;
}

.ml8 {
    margin-left: 8px;
}

.w80 {
    width: 80px;
}

.w120 {
    width: 120px;
}

:deep(.el-checkbox__inner) {
    margin-right: 5px;
}
</style>